<template>
  <v-dialog v-model="myValue" persistent max-width="960">
    <v-card>
      <v-card-title class="headline">告知函</v-card-title>
      <v-card-text>
        <v-row
          style="margin-top: 50px"
          justify="center"
          no-gutters
          class="px-5"
        >
          <v-col cols="auto" class="text-subtitle-1 red--text">
            {{ tips }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" @click="myValue = false">取消</v-btn>
        <v-btn color="primary darken-1" @click="onRefOk">同意</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { asgLtcRawDownloadUrlConsent } from "@/plugins/api";
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onRefOk() {
      const params = {
        projectNo: this.myData.xmfah,
      };
      asgLtcRawDownloadUrlConsent(params).then(({ data }) => {
        if (data) {
          this.$message.success("生成下载链接成功。");
          this.myValue = false;
          this.$emit("query");
        } else {
          this.$message.console.error("生成下载链接失败。");
        }
      });
    },
  },
  data() {
    return {};
  },
  computed: {
    myData() {
      return this.data;
    },
    myValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    tips() {
      return `生成下载链接，即表示您已接收到文件下载地址，并同意原始文件于${this.Utility.fmtTime(
        this.myData.expireDate,
        "yyyy年MM月dd日"
      )}自动销毁！`;
    },
  },
  created() {},
};
</script>
